import { initSehai } from '@pdfe/sehai'

// 初始化aiChatBi
export default function initAiChatBiSdk(userId: string, prompts: { prologue: string, question: string[] }) {
  const aiChatBi = initSehai({
    apiBase: 'https://dify-api.sf-express.com/v1',
    apiKey: 'app-GdYstUNNRI9zaBCUpd1s7Vr2',
    userId,
    platform: 'linghui',
    mode: 'single',
    appType: 'agent',
    introduction: prompts.prologue || '你好，我是小Q，我可以为你分析质量相关的问题哦。你可以进行以下操作： 1.进行运单的奖惩分析; 2.进行运单的赔偿分析。',
    presetQuestions: prompts.question || ['要分析运单的奖惩情况？', '要分析运单的赔偿情况？'],
    input: {
      userNo: userId,
  }
  })
  return aiChatBi
}
